import React, {useState} from 'react';
import {Helmet} from 'react-helmet';
import {Header, Title, ContainerHeader} from './Header';
import Button from '../components/Button';
import {CustomForm, Input, SpanError} from './Elements';
import {ReactComponent as SvgLogin} from '../images/login.svg';
import styled from 'styled-components';
import {useNavigate} from 'react-router-dom';
import {auth, db} from '../firebase/firebaseConfig';
import { signInWithEmailAndPassword } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";

const Svg = styled(SvgLogin)`
	width: 100%;
	max-height: 15rem; 
`;

const Login = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [message, setMessage] = useState({});

	const handleChange = (e) => {
		if(e.target.name === 'email'){
			setEmail(e.target.value);
		} else if (e.target.name === 'password'){
			setPassword(e.target.value);
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		setMessage({});

		// Comprobamos del lado del cliente que el correo sea valido.
		const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
		if( !expresionRegular.test(email) ){
			setMessage({
				tipo: 'error',
				mensaje: 'Por favor ingresa un correo electrónico valido'
			});
			return;
		}

		if(email === '' || password === ''){
			setMessage({
				tipo: 'error',
				mensaje: 'Por favor rellena todos los datos'
			});
			return;
		}

		try {
			await signInWithEmailAndPassword(auth, email, password);
			// Luego obtienes el UID del usuario autenticado
			const user = auth.currentUser;
			const uid = user.uid;

			const q = query(collection(db, 'config'), where('userId', '==', uid));
			const querySnapshot = await getDocs(q);

			if (querySnapshot.empty) {
				setMessage({
					tipo: 'error',
					mensaje: 'Login inválido.'
				});
				return;
			}

			const config = querySnapshot.docs[0].data();

			if (config.approved !== true) {
				setMessage({
					tipo: 'error',
					mensaje: 'Tu cuenta está pendiente de aprobación.'
				});
				return;
			}
			
			navigate('/');
		} catch(error) {
			let mensaje;
			switch(error.code){
				case 'auth/wrong-password':
					mensaje = 'La contraseña no es correcta.'
					break;
				default:
					mensaje = 'Hubo un error al intentar ingresar a su cuenta.'
				break;
			}

			setMessage({tipo: 'error', mensaje: mensaje});
		}
	}

	return (
		<>
			<Helmet>
				<Title>Ventas WYM</Title>
			</Helmet>

			<Header>
				<ContainerHeader>
					<div>
						<Button to="/register">Registrarse</Button>
					</div>
				</ContainerHeader>
			</Header>

			<CustomForm onSubmit={handleSubmit}>
				<Svg />
				<Input 
					type="email"
					name="email"
					placeholder="Correo Electrónico"
					value={email}
					onChange={handleChange}
				/>
				<Input 
					type="password"
					name="password"
					placeholder="Contraseña"
					value={password}
					onChange={handleChange}
				/>
				<Button as="button" primario={"Primario"} type="submit">Iniciar Sesión</Button>
				<div>
					<SpanError><strong>{message.mensaje}</strong></SpanError>
				</div>
			</CustomForm>
			
		</>
	);
}
 
export default Login;